import React from "react";
import './styles/landing.css'

const Features = (props) => {
  return (
    <div id="features" className="text-center" style={{ 
      scrollMarginTop: "60px",
      paddingTop: "10px",
      marginTop: "1px",
      paddingBottom:"20px"
    }}>
      <div className="container">
        <div className="row">
          <div className="section-title">
            <h2>Fitur Layanan</h2>
          </div>
        </div>

        {/* Kelompok Fitur Pertama */}
        <div className="mb-3">
          <h3 className="mb-3" style={{ borderBottom: "2px solid #608dfd", paddingBottom: "10px", display: "inline-block" }}>
            Sistem Pelayanan Pengguna Jasa
          </h3 >
          <div className="row" >
            {props.data?.slice(0, 3).map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-xs-6 col-md-4">
                <a
                  href={d.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white"
                >
                  <div className="feature-box d-flex flex-column align-items-center text-center ">
                    <img 
                      src={d.icon} 
                      alt={d.title} 
                      className="mb-3" 
                      style={{ objectFit: "contain",}} 
                    />
                    <h3 className="fw-bold mb-2 text-uppercase">{d.title}</h3>
                    <p className="medium text-white">{d.text}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Kelompok Fitur Kedua */}
        <div>
          <h3 className="mb-3" style={{ borderBottom: "2px solid #608dfd", paddingBottom: "6px", display: "inline-block" }}>
            Sistem Internal Badan Mutu KKP
          </h3>
          <div className="row">
            {props.data?.slice(3).map((d, i) => (
              <div key={`${d.title}-${i+3}`} className="col-xs-6 col-md-4">
                <a
                  href={d.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <div className="feature-box d-flex flex-column align-items-center text-center ">
                    <img 
                      src={d.icon} 
                      alt={d.title} 
                      className="mb-3" 
                      style={{ objectFit: "contain",}} 
                    />
                    <h3 className="fw-bold mb-2 text-uppercase">{d.title}</h3>
                    <p className="medium text-white">{d.text}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>

        {!props.data && <p>Loading...</p>}
      </div>
    </div>
  );
};

export default Features;